<template>
  <div class="calcFormsForm testCalculationForms">
    <div v-if="isloadingData">
      <span>
        <v-progress-circular
          indeterminate
          :size="20"
          color="blue lighten-5"
          class="mr-2"
        ></v-progress-circular
        >Loading..
      </span>
    </div>
    <div v-else-if="testItem">
      <v-form ref="testCalculationForm" v-model="isFormValid">
        <div class="inputContainer">
          <v-text-field
            label="Calculation"
            v-model="testItem.ShortName"
            :rules="[rules.required]"
            dense
            outlined
            readonly
          ></v-text-field>
        </div>
        <div class="inputContainer">
          <v-text-field
            label="Member"
            v-model="memberId"
            :rules="[rules.required]"
            dense
            outlined
          ></v-text-field>
          <v-alert v-if="!memberId" type="info" outlined dense>
            Please select a member on the members page or enter member ID
          </v-alert>
        </div>
        <div class="inputContainer">
          <v-select
            v-model="formId"
            :items="forms"
            item-text="ShortName"
            item-value="Id"
            label="Input Form"
            :rules="[rules.required]"
            outlined
            dense
          ></v-select>
        </div>
        <div class="inputContainer">
          <v-text-field label="Result" v-model="result" dense outlined></v-text-field>
        </div>
      </v-form>
      <div class="formFooter">
        <div class="btnContainer">
          <div></div>
          <div>
            <v-btn color="primary" outlined @click="onCancel" class="mr-2"> Cancel </v-btn>
            <v-btn color="primary" depressed @click="onCalculate"> Calculate </v-btn>
          </div>
        </div>
      </div>
      <div v-if="showResultTable" class="resultTable">
        <v-data-table
          :headers="resultHeaders"
          :items="resultItems"
          item-key="key"
          :items-per-page="-1"
          :loading="isLoadingCalculation"
          loading-text="Loading calculation..."
          :calculate-widths="true"
          dense
        >
        </v-data-table>
      </div>
    </div>
    <div v-else>
      <v-alert outlined type="info" dense> No data. </v-alert>
    </div>

    <v-dialog v-model="dialog" max-width="500" persistent>
      <Calculation
        :formName="selectedFormName"
        :currentPlanId="planId"
        @calculateClick="onTestCalculation"
        :returnInputs="true"
      />
    </v-dialog>
  </div>
</template>

<script>
import Calculation from '@/views/Members/Leavers/Calculation.vue';

export default {
  name: 'TestCalculationForm',
  components: { Calculation },
  props: {
    testItem: { type: Object },
    planId: { type: Number },
  },
  data() {
    return {
      isFormValid: false,
      isCalculationInputFormValid: false,
      isloadingData: false,
      isloadingFormInputs: false,
      isLoadingCalculation: false,
      dialog: false,
      memberId: null,
      formId: null,
      result: null,
      forms: [],
      calculationInputs: [],
      rules: {
        required: (value) => !!value || 'Required.',
      },
      resultHeaders: [
        { text: 'Key', value: 'key' },
        { text: 'Value', value: 'value' },
      ],
      resultItems: [],
    };
  },
  created: function () {
    this.memberId = this.selectedMemberId;
    this.getForms();
  },
  computed: {
    selectedMemberId() {
      return this.$store.getters.selectedMemberId;
    },
    selectedFormName() {
      if (this.forms && this.forms.length > 0 && this.formId) {
        const form = this.forms.find((x) => {
          return x.Id == this.formId;
        });
        if (form) return form.ShortName;
      }
      return '';
    },
    showResultTable() {
      return this.resultItems && this.resultItems.length > 0;
    },
  },
  watch: {
    testItem: function () {
      this.resultItems = [];
      this.result = null;
    },
  },
  methods: {
    onCancel() {
      this.resultItems = [];
      this.result = null;
      this.$emit('cancelTestCalculation');
    },
    onCalculate() {
      const isFormValid = this.$refs.testCalculationForm.validate();
      if (isFormValid) {
        this.dialog = true;
      }
    },
    onCancelCalculation() {
      this.dialog = false;
    },
    onTestCalculation(val, data) {
      this.dialog = false;
      if (val == 'calculate') {
        console.log(data);
        this.testCalculation(data);
      }
      if (val == 'cancel') {
        this.dialog = false;
      }
    },
    async getForms() {
      this.isloadingData = true;
      try {
        const response = await this.$api.get(
          `/Calculation/GetCalculationItems?planId=${this.planId}&calcType=Forms&groupId=0`
        );

        this.forms = response.data;
        if (this.planId > 0) {
          const systemFormsResponse = await this.$api.get(
            `/Calculation/GetCalculationItems?planId=0&calcType=Forms&groupId=0`
          );

          this.forms = this.forms.concat(systemFormsResponse.data);
        }
      } catch (error) {
        console.log(error.message);
      } finally {
        this.isloadingData = false;
      }
    },
    async testCalculation(inputs) {
      try {
        const model = {
          MembershipId: this.memberId,
          InputFormId: this.formId,
          CalculationId: this.testItem.Id,
          Inputs: inputs,
        };
        this.resultItems = [];
        let response = await this.$api.post('/Calculation/TestCalculation', model);

        if (!response.data) {
          const msg = 'Unable to load test calculation';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        if (response.data) {
          const data = response.data;
          this.result = data.Value;
          Object.keys(data.Results).forEach((e) => {
            var key = e;
            this.resultItems.push({ key: key, value: data.Results[key] });
          });
        }
      } catch (err) {
        console.error(err.response.data);
        if (err.response?.data?.ExceptionType.includes("AbortCalculationException")){
          const msg = `Calculation Aborted - ${err.response.data.ExceptionMessage}`;
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }
        
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
